import { render, staticRenderFns } from "./ServiceOrderManagement.vue?vue&type=template&id=4b5e3d7c&scoped=true"
import script from "./ServiceOrderManagement.vue?vue&type=script&lang=js"
export * from "./ServiceOrderManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceOrderManagement.vue?vue&type=style&index=0&id=4b5e3d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5e3d7c",
  null
  
)

export default component.exports